import { render, staticRenderFns } from "./ComponentsAccordion.vue?vue&type=template&id=0bc52e51&scoped=true"
import script from "./ComponentsAccordion.vue?vue&type=script&lang=js"
export * from "./ComponentsAccordion.vue?vue&type=script&lang=js"
import style0 from "./ComponentsAccordion.vue?vue&type=style&index=0&id=0bc52e51&prod&lang=scss&scoped=true"
import style1 from "./ComponentsAccordion.vue?vue&type=style&index=1&id=0bc52e51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc52e51",
  null
  
)

export default component.exports